import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;
const ADMIN_TOKEN_KEY = 'naraze_admin_token';

export function getAdminToken() {
  return localStorage.getItem(ADMIN_TOKEN_KEY) || '';
}

export function setAdminToken(token) {
  localStorage.setItem(ADMIN_TOKEN_KEY, token);
}

export function clearAdminToken() {
  localStorage.removeItem(ADMIN_TOKEN_KEY);
}

export function getAdminHeaders() {
  const token = getAdminToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function loginAdmin(username, password) {
  const response = await axios.post(`${API}/auth.php`, { username, password });
  return response.data;
}

export async function verifyAdminToken() {
  const response = await axios.get(`${API}/auth.php`, {
    headers: getAdminHeaders(),
  });
  return response.data;
}

export { API };
